import { CircularProgress } from "@mui/material"

export const AppSpinnerLoader = () => {
    return (
        <span >
        <CircularProgress size={"15px"} />
      </span>
    )
}